import { useDispatch } from "react-redux";
import { logout as logoutService } from "../services/LogoutService";

export const useLogout = () => {
  const dispatch = useDispatch();

  return async () => {
    await logoutService(dispatch);
  };
};